import EventBusyIcon from "@mui/icons-material/EventBusy";
import { Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningIcon from "@mui/icons-material/Warning";
import Translate from "../../../utils/Translate";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { formatDate } from "../../../utils/dateTimeFormat";
import { Block } from "@mui/icons-material";

// status från backend
const permitDbStatus = Object.freeze({
  waitingForResponsibleSignature: 0,
  signedByResponsibleAndPermitWaitingForDriverSignature: 1,
  signedByResponsibleAndDriver: 2,
  signedByResponsibleAndPermitMessageToDriverBounced: 3,
  messageToResponsibleBounced: 4,
  manuallySigned: 5,
  expired: 6,
});

const permitStatusGuiOrder = Object.freeze({
  waitingForResponsibleSignature: 0,
  signedByResponsibleAndPermitWaitingForDriverSignature: 1,
  signedByResponsibleAndDriver: 2,
  signedByResponsibleAndPermitMessageToDriverBounced: 3,
  messageToResponsibleBounced: 4,
  manuallySigned: 5,
  expired: 6,
  expiresSoon: 7,
});

// siffrorna markerar vilken ordning körtillstånden sorteras i
// siffrorna används också för att veta vilka ikoner och översättningar som ska renderas
// const permitStatusGuiOrder = Object.freeze({
//   messageToResponsibleBounced: 1,
//   signedByResponsibleAndPermitMessageToDriverBounced: 2,
//   waitingForResponsibleSignature: 3,
//   signedByResponsibleAndPermitWaitingForDriverSignature: 4,
//   signedByResponsibleAndDriver: 5,
//   manuallySigned: 6,
//   expired: 7,
// });

export const permitStatusToSortableValue = (permit) => {
  return permit?.status;

  // switch(permit.status)
  // {
  //   case permitDbStatus.waitingForResponsibleSignature:
  //     return permitStatusGuiOrder.waitingForResponsibleSignature;

  //   case permitDbStatus.signedByResponsibleAndPermitWaitingForDriverSignature:
  //     return permitStatusGuiOrder.signedByResponsibleAndPermitWaitingForDriverSignature;

  //   case permitDbStatus.signedByResponsibleAndDriver:
  //     return permitStatusGuiOrder.signedByResponsibleAndDriver;

  //   case permitDbStatus.signedByResponsibleAndPermitMessageToDriverBounced:
  //     return permitStatusGuiOrder.signedByResponsibleAndPermitMessageToDriverBounced;

  //   case permitDbStatus.messageToResponsibleBounced:
  //     return permitStatusGuiOrder.messageToResponsibleBounced;

  //   case permitDbStatus.manuallySigned:
  //     return permitStatusGuiOrder.manuallySigned;

  //   case permitDbStatus.expired:
  //     return permitStatusGuiOrder.expired;

  //   case null:
  //   case undefined:
  //     return null;

  //   default:
  //     throw new Error(`Status ${permit?.status} not defined`);
  // }

  // const validTo = permit.validTo && new Date(permit.validTo);
  // const isExpired = isValidDate(validTo) ? validTo < Date.now() : false;
  // if (isExpired) {
  //   // PermitExpired
  //   return permitStatusGuiOrder.expired;
  // }

  // if (permit.blobFile !== null) {
  //   return permitStatusGuiOrder.manuallySigned; //ManuallySigned
  // }

  // const isSignedByResponsible = !!permit.responsibleSignatureId;
  // const hasResponsibleSignEmailBounced = !isSignedByResponsible && permit.responsibleSignCommunicationBounced;
  // if (hasResponsibleSignEmailBounced) {
  //   // PermitMessageToResponsibleBounced
  //   return permitStatusGuiOrder.messageToResponsibleBounced;
  // }

  // const isSignedByResponsibleAndDriver = isSignedByResponsible && !!permit.signatureId;
  // const hasDriverSignEmailBounced = !isSignedByResponsibleAndDriver && permit.signCommunicationBounced;
  // if (isSignedByResponsible && hasDriverSignEmailBounced) {
  //   // PermitSignedByResponsible + PermitMessageToDriverBounced
  //   return permitStatusGuiOrder.signedByResponsibleAndPermitMessageToDriverBounced;
  // }

  // if (isSignedByResponsibleAndDriver) {
  //   // PermitSignedByResponsibleAndDriver
  //   return permitStatusGuiOrder.signedByResponsibleAndDriver;
  // }

  // if (isSignedByResponsible) {
  //   // PermitSignedByResponsible + PermitWaitingForDriverSignature
  //   return permitStatusGuiOrder.signedByResponsibleAndPermitWaitingForDriverSignature;
  // }

  // // PermitWaitingForResponsibleSignature
  // return permitStatusGuiOrder.waitingForResponsibleSignature;
};

export const renderPermitStatus = (permitStatus, permit) => {
  const className = "iconbox opaque";
  let statusText1 = "",
    statusText2 = "";
  switch (permitStatus) {
    case permitStatusGuiOrder.manuallySigned:
      statusText1 = Translate.get("ManuallySigned");
      return wrapPermitStatusIcon(<EditNoteIcon />, statusText1, concatClassName(className, "success"));
    case permitStatusGuiOrder.expired:
      let icon;
      if (permit.inactivationDate || permit.inactivationActorName || permit.inactivationNote) {
        icon = <Block />;
        statusText1 = Translate.get("PermitInactivated");
        if (permit.inactivationActorName) {
          statusText1 += ` ${Translate.get("By")}: ${permit.inactivationActorName}`;
        }
        if (permit.inactivationDate) {
          statusText1 += `${permit.inactivationActorName ? ", " : " "} ${formatDate(permit.inactivationDate)}`;
        }
        if (permit.inactivationNote) {
          statusText1 += ` ${Translate.get("Reason")}: ${permit.inactivationNote}`;
        }
      } else {
        icon = <EventBusyIcon />;
        statusText1 = Translate.get("PermitExpired");
      }
      return wrapPermitStatusIcon(icon, statusText1, concatClassName(className, "warning"));

    case permitStatusGuiOrder.expiresSoon:
      statusText1 = Translate.get("PermitExpiresInXDays").replace("{days}", 7);
      return wrapPermitStatusIcon(<WarningIcon />, statusText1, concatClassName(className, "blue"));
    case permitStatusGuiOrder.messageToResponsibleBounced:
      statusText1 = `${Translate.get("PermitMessageToResponsibleBounced")} ${formatSendDate(permit.lastResponsibleSignCommunicationSendDate)}`;
      return wrapPermitStatusIcon(<WarningIcon />, statusText1, concatClassName(className, "warning"));
    case permitStatusGuiOrder.signedByResponsibleAndPermitMessageToDriverBounced:
      statusText1 = Translate.get("PermitSignedByResponsible");
      statusText2 = `${Translate.get("PermitMessageToDriverBounced")} ${formatSendDate(permit.lastSignCommunicationSendDate)}`;
      return (
        <>
          {wrapPermitStatusIcon(<DoneIcon />, statusText1, concatClassName(className, "success"))}
          {wrapPermitStatusIcon(<WarningIcon />, statusText2, concatClassName(className, "warning"))}
        </>
      );
    case permitStatusGuiOrder.signedByResponsibleAndDriver:
      statusText1 = Translate.get("PermitSignedByResponsibleAndDriver");
      return wrapPermitStatusIcon(<DoneAllIcon />, statusText1, concatClassName(className, "success"));
    case permitStatusGuiOrder.signedByResponsibleAndPermitWaitingForDriverSignature:
      statusText1 = Translate.get("PermitSignedByResponsible");
      statusText2 = `${Translate.get("PermitWaitingForDriverSignature")} ${formatSendDate(permit.lastSignCommunicationSendDate)} ${formatNumberSent(permit.numberOfSentHolderSigncommunications)}`;
      return (
        <>
          {wrapPermitStatusIcon(<DoneIcon />, statusText1, concatClassName(className, "success"))}
          {wrapPermitStatusIcon(<AccessTimeIcon />, statusText2, className)}
        </>
      );
    case permitStatusGuiOrder.waitingForResponsibleSignature:
      statusText1 = `${Translate.get("PermitWaitingForResponsibleSignature")} ${formatSendDate(permit.lastResponsibleSignCommunicationSendDate)} ${formatNumberSent(permit.numberOfSentResponibleSigncommunications)}`;
      return wrapPermitStatusIcon(<AccessTimeIcon />, statusText1, className);

    default:
      return <></>;
  }
};

const formatSendDate = (sendDate) => (sendDate ? formatDate(sendDate) : "");
const formatNumberSent = (numberSentMessages) =>
  Number.isInteger(numberSentMessages) ? `(${numberSentMessages})` : "";

export const formatPermitStatus = (permitStatus) => {
  switch (permitStatus) {
    case permitStatusGuiOrder.manuallySigned:
      return Translate.get("ManuallySigned");

    case permitStatusGuiOrder.expired:
      return Translate.get("PermitExpired");

    case permitStatusGuiOrder.messageToResponsibleBounced:
      return Translate.get("PermitMessageToResponsibleBounced");

    case permitStatusGuiOrder.signedByResponsibleAndPermitMessageToDriverBounced:
      return `${Translate.get("PermitSignedByResponsible")}, ${Translate.get("PermitMessageToDriverBounced")}`;

    case permitStatusGuiOrder.signedByResponsibleAndDriver:
      return Translate.get("PermitSignedByResponsibleAndDriver");

    case permitStatusGuiOrder.signedByResponsibleAndPermitWaitingForDriverSignature:
      return `${Translate.get("PermitSignedByResponsible")}, ${Translate.get("PermitWaitingForDriverSignature")}`;

    case permitStatusGuiOrder.waitingForResponsibleSignature:
      return Translate.get("PermitWaitingForResponsibleSignature");

    default:
      return "";
  }
};

const concatClassName = (className, classNameToAdd) => {
  return className + (classNameToAdd ? ` ${classNameToAdd}` : "");
};

const wrapPermitStatusIcon = (icon, statusText, className) => {
  return (
    <Tooltip className={className} title={statusText}>
      {icon}
    </Tooltip>
  );
};
